export default __webpack_public_path__ + "4a5e2e3670c61554dc98b05890e0d0d8.svg";